import { JSX, ReactNode } from 'react';
import './style.scss';
import { useEffect, useState } from 'react';
import { getEnvironment, isInIframe } from '@/utils/Mobile';
import ToastUtils from '@/utils/ToastUtils';

type CallbackDataType = {
    business_id: string;
    course_id: string;
    resource_id: string;
    duration: string;
}
type TagPropType = {
    business_id: string;
    duration: string;
    children?: ReactNode | JSX.Element | JSX.Element [];
    onClick?: (data: TagPropType | null) => void;
};
export const CustomLink = (props: TagPropType) => {
    const [data, setData] = useState<CallbackDataType | null>(null);
    let { children } = props;
    const getData = () => {
        const [business_id, course_id, resource_id] = props?.business_id.split('_') || [];
        const duration = props?.duration || '';
        setData({ business_id, course_id, resource_id, duration });
    };
    const onClick = (data: TagPropType | null) => {
        if (props.onClick) {
            return props.onClick(data);
        }
        const env = getEnvironment();
        if (env === 'h5' || env === 'pc') {
            if (isInIframe()) return window.parent?.postMessage({ type: 'QA_CLICK_CALLBACK', data }, '*');
            return ToastUtils.showToast('当前使用场景不支持');
        } else if (env === 'app') {
            //@ts-ignore
            if (window.ReactNativeWebView) return window.ReactNativeWebView.postMessage(JSON.stringify({
                type: 'jumptime',
                data
            }));
        }
        ToastUtils.showToast('当前使用场景不支持');
        return false;
    };
    useEffect(() => {
        getData();
    }, []);
    return (
        <span onClick={() => onClick(data)} className="grt-custom-link">{children}</span>
    );
};

export default CustomLink;
